import Vue from 'vue';

Vue.component('contact-component', {
    props: {},

    data() {
        return {}
    },

    mounted() { },

    methods: {},

    beforeDestroy() { }
});